import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useDisclosure,
} from "@chakra-ui/react"
import React from "react"
import { api } from "../../../../services/api"

export function ConfirmDialog({ item, resultado }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()

  async function updateUsu() {
    const params = {
      usuario: JSON.parse(localStorage.getItem("authentication")).codigo_usuario,
      numero_nota: item.numero_nota,
      numero_unico: item.numero_unico,
      codigo_produto: item.codigo_produto,
      sequencia: item.sequencia,
    }

    const response = await api.post("/site/v2/pedido/atualiza-usu-impressao-nota", params)

    console.log("response: ", response)

    onClose()
    resultado({
      codigo_parceiro: "",
      numero_pedido: "",
      data_entrada: "",
      data_saida: "",
      pendente: "",
      nfe: "",
    })
    // window.location.reload()
  }

  return (
    <>
      <Button onClick={onOpen} colorScheme="blue" size="sm">
        OK
      </Button>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Tem certeza?</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            Você está prestes a confirmar o pedido <strong>{item.numero_pedido}</strong>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button onClick={() => updateUsu()} colorScheme="blue">
              Sim
            </Button>
            <Button colorScheme="red" ref={cancelRef} onClick={onClose} ml={3}>
              Não
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
